import pick from 'lodash/pick';

// Utils
import { editorStateToJsonString } from 'Wpds/components/rich-text/utils/EditorState.utils';

// Constants
import { GoalWhiteList } from './constants';

// Types
import { PrivacyType, ReminderType } from './types';

function getViewSettings(values) {
  switch (values.privacy) {
    case PrivacyType.justMe:
      return { viewSetting: 'me' };
    case PrivacyType.everyone:
      return { viewSetting: 'everyone' };
    case PrivacyType.meAndATeammate:
      return { viewSetting: 'teammate', viewerId: values.teammateId };
    case PrivacyType.meAndChoosenTeammate:
      return { viewSetting: 'teammate', viewerId: values.assigneeId };
    case PrivacyType.groupWorkspace:
      return { viewSetting: 'groupWorkspace', groupWorkspaceId: values.groupWorkspaceId, viewerId: values.assigneeId };
    default:
      return { viewSetting: 'me' };
  }
}

function getRecurrenceAttributes(values) {
  switch (values.reminder) {
    case ReminderType.daily:
      return {
        at: 'Monday 8:30,Tuesday 8:30,Wednesday 8:30,Thursday 8:30,Friday 8:30',
        intervalUnit: 'week',
        intervalAmount: 1,
        active: true,
      };
    case ReminderType.onceAWeek:
      return {
        at: 'Monday 8:30',
        intervalUnit: 'week',
        intervalAmount: 1,
        active: true,
      };
    case ReminderType.everyOtherWeek:
      return {
        at: 'Monday 8:30',
        intervalUnit: 'week',
        intervalAmount: 2,
        active: true,
      };
    case ReminderType.onceAMonth:
      return {
        at: 'Monday 8:30',
        intervalUnit: 'week',
        intervalAmount: 4,
        active: true,
      };
    case ReminderType.never:
      return {
        at: 'Monday 8:30',
        intervalUnit: 'week',
        intervalAmount: 1,
        active: false,
      };
    default:
      return {
        at: 'Monday 8:30',
        intervalUnit: 'week',
        intervalAmount: 1,
        active: true,
      };
  }
}

export function generateGoal(values, goal) {
  return {
    ...pick(values, GoalWhiteList),
    ...getViewSettings(values, goal),
    recurrenceAttributes: getRecurrenceAttributes(values),
  };
}

export function generateGoalV2(values) {
  return {
    ...pick(values, GoalWhiteList),
    private: values.privacy === 'private',
    recurrenceAttributes: getRecurrenceAttributes(values),
    description: editorStateToJsonString(values.description),
  };
}
